import type { IUnifiedOrderBlotterEntry } from 'apiConnector/blotters';
import { ClientSideBlotterGrid } from 'components/shared/Blotter/Grid/client-side-blotter';

import { connectSecondaryMarketOrderBlotterGrid } from './Grid.connect';

export const SecondaryMarketOrderBlotterGrid = connectSecondaryMarketOrderBlotterGrid(
  ClientSideBlotterGrid<IUnifiedOrderBlotterEntry>,
);
